import React from 'react';
import { css } from '@emotion/css';
import cert1 from 'evcharging/assets/ev-charger/cert1.png';
import cert2 from 'evcharging/assets/ev-charger/cert2.png';
import cert3 from 'evcharging/assets/ev-charger/cert3.png';
import cert4 from 'evcharging/assets/ev-charger/cert4.png';
import cert5 from 'evcharging/assets/ev-charger/cert5.png';
import Image from 'next/image';
import { Theme } from 'evcharging/app/themes';
import Link from 'evcharging/components/Link';
import { OCPP_URL, OPEN_ADR_URL } from 'evcharging/app/seo/urls';
import useI18n from 'evcharging/hooks/useI18n';
import useTheme from 'evcharging/hooks/useTheme';

const Certification = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <div className={styles.root}>
      <label className={styles.text}>{t('charger.calc.certification')}</label>
      <div className={styles.certs}>
        <Image src={cert1} alt={'CE'} width={29} height={29} />
        <Image src={cert2} alt={'UL'} width={29} height={29} />
        <Image src={cert3} alt={'Energy Star'} width={29} height={29} />
        <Link href={OCPP_URL}>
          <Image src={cert4} alt={'occp'} width={33} height={23} />
        </Link>
        <Link href={OPEN_ADR_URL}>
          <Image src={cert5} alt={'open adr'} width={98} height={20} />
        </Link>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 430px;

    ${theme.breakpoints.mobile.down} {
      display: inline-block;
    }
  `,
  text: css`
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-transform: uppercase;
    color: #6e7c87;
  `,
  certs: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 270px;

    ${theme.breakpoints.mobile.down} {
      margin-top: 12px;
    }
  `,
});

export default Certification;
